<template>
  <div class="body-entirety">
    <!-- 双选会说明和Img -->
    <div class="top-body" ref="form">
      <!-- Img -->
      <div class="top-body-left">
        <img :src="form.mutualPicture" alt="" :style="{ width: '392px', height: '294px' }" />
      </div>
      <!-- 信息说明 -->
      <div class="top-body-right">
        <!-- 信息标题 -->
        <div class="top-body-right-one">{{ form.mutualName }}</div>
        <!-- 线下参会 进行中 场次规模 等... -->
        <div class="top-body-right-two">
          <div class="top-body-right-two-1">
            <span v-if="form.mutualParticipation == 1">线上参会</span>
            <span v-if="form.mutualParticipation == 2">线下参会</span>
          </div>
          <div class="top-body-right-two-4" v-if="form.presell == 2">
            <span v-if="form.presell == 2">场次预售</span>
          </div>
          <div class="top-body-right-two-2">
            <span v-if="form.status == 0">未开始</span>
            <span v-if="form.status == 1">进行中</span>
            <span v-if="form.status == 2">已结束</span>
          </div>
          <div class="top-body-right-two-3" style="margin-top: 25px">场次规模：{{ form.riseScale }}-{{ form.endScale }} 家企业</div>
        </div>
        <!-- 时间 or 地点 -->
        <div class="top-body-right-three">
          <div class="top-body-right-three-1">
            <div class="top-body-right-three-1-1">
              <span class="iconfont" style="font-size:40px">&#xe60f;</span>
            </div>
            <div class="top-body-right-three-1-2">
              {{ formatDateTime(form.schoolProcessList[0].handleTime) }}
            {{ formatDateTime(form.schoolProcessList[1].handleTime, false) }}
            </div>
          </div>
          <div class="top-body-right-three-2">
            <div class="top-body-right-three-2-1">
              <span class="iconfont" style="font-size:35px">&#xe602;</span>
            </div>
            <div class="top-body-right-three-2-2">
              {{ form.conferenceAddress }}
            </div>
          </div>
        </div>
        <!-- 报名参会 按钮 支付说明 -->
        <div class="top-body-right-four">
          <div class="top-body-right-four-1">
            <span><el-button type="primary" round :disabled="disabled" v-if="form.status == 0">未开始</el-button></span>
            <span><el-button type="primary" round :disabled="disabled" v-if="form.status == 1">已结束</el-button></span>
            <span><el-button type="primary" round :disabled="disabled" v-if="form.status == 2">报名参会</el-button></span>
          </div>
          <div class="top-body-right-four-2">
            <div class="top-body-right-four-2-2">
              <img src="../../assets/icon/explain.png" alt="说明" />
              <el-tooltip class="item" effect="dark" placement="top">
                <div slot="content">
                  1.支付的金额将自动兑换为校园通用点<br />数，用于本场报名消耗(1元=1点数);<br />
                  2.若报名未通过，资产将自动返还您的账<br />号(资产有效期365天)，可继续用于其他<br />线下双选会报名消耗;<br />
                  3.距开场时间3个工作日内不支持退费。
                </div>
                <span>支付说明</span>
              </el-tooltip>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="second-body">
      <div class="second-body-one">
        <div class="second-body-size">参会说明</div>
        <div class="second-body-one-2 gl-container ql-snow">
          <div class="ql-editor">
            <div v-html="form.richText"></div>
          </div>
        </div>
      </div>
      <div class="second-body-two">
        <div class="second-body-size">高校信息</div>
        <div ref="schoolDictionaries" class="second-body-two-2">
          <div>
            <img :src="schoolDictionaries.schoolBadge" alt="高校信息" :style="{ width: '56px', height: '56px' }" />
          </div>
          <div class="second-body-two-3">{{ schoolDictionaries.name }}</div>
          <div class="second-body-two-4">
            <span class="shuxian">{{ schoolDictionaries.address }}</span>
            <span v-for="schoolCategory in schoolCategoryList" :key="schoolCategory.id">
              <span v-if="schoolCategory.id == schoolDictionaries.schoolCategory">{{
                schoolCategory.name
              }}</span>
            </span>
            <div class="second-body-two-5">
              <span v-for="featureId in schoolDictionaries.schoolFeature" :key="featureId.id">
                <span v-for="schoolFeature in schoolFeatureList" :key="schoolFeature.id">
                  <span v-if="schoolFeature.id === featureId" class="message-schoolFeature">
                    {{ schoolFeature.name }}
                  </span>
                </span>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Quill from "quill";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
export default {
  data() {
    return {
      id: "",
      form: {},
      schoolDictionaries: {},
      disabled: true,
      schoolCategoryList: [],
      schoolFeatureList: [],
    };
  },
  created() {
    if (this.$route.query.id) {
      this.id = this.$route.query.id;
    }
    this.getList();
    this.getSchoolDoubleChannel();
    this.getSchoolCategory();
    this.getSchoolFeature();
  },
  methods: {
    getList() {
      let _this = this;
      const param = {
        id: this.id,
      };
      _this.$api.universities.getSchoolDoubleChannel(param).then((response) => {
        if (response.data.status == 2) {
          this.disabled = false;
        }
        this.form = response.data;
      });
    },
    formatDateTime(dateString, showDate = true) {
      const date = new Date(dateString);
      const month = ("0" + (date.getMonth() + 1)).slice(-2);
      const day = ("0" + date.getDate()).slice(-2);
      const hours = ("0" + date.getHours()).slice(-2);
      const minutes = ("0" + date.getMinutes()).slice(-2);
      const seconds = ("0" + date.getSeconds()).slice(-2);
      if (showDate) {
        const year = date.getFullYear();
        return `${month}月${day}日 ${hours}:${minutes}:${seconds} - `;
      } else {
        return `${month}月${day}日 ${hours}:${minutes}:${seconds}`;
      }
    },
    // 查询院校类别
    getSchoolCategory() {
      this.$api.universities.getSchoolCategory().then((response) => {
        for (let i = 0; i < response.data.length; i++) {
          this.schoolCategoryList.push({
            id: response.data[i].dictValue,
            name: response.data[i].dictLabel,
          });
        }
      });
    },
    getSchoolDoubleChannel() {
      let param = {
        id: this.id,
      };
      this.$api.universities.getSchoolDictionaries(param).then((response) => {
        this.schoolDictionaries = response.data;
      });
    },
    // 查询院校特色
    getSchoolFeature() {
      this.$api.universities.getSchoolFeature().then((response) => {
        for (let i = 0; i < response.data.length; i++) {
          this.schoolFeatureList.push({
            id: response.data[i].dictValue,
            name: response.data[i].dictLabel,
          });
        }
      });
    },
  },
};
</script>
<style scoped>
@import "../../assets/icon/iconfont.css";
.body-entirety {
  background: #f8f9fc;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.top-body {
  width: 100%;
  height: 350px;
  padding: 25px;
  background: #f8f9fc;
}
.top-body-left {
  margin-left: 12%;
  float: left;
}
.top-body-right {
  float: left;
  width: 50%;
  height: 270px;
  padding: 50px;
  background: #ffffff;
  margin: 15px;
  border-radius: 25px;
}
.top-body-right-one {
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  color: #141933;
  display: -webkit-box;
  font-size: 20px;
  font-weight: 500;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: normal;
  word-break: break-all;
}
.top-body-right-two {
  width: 50%;
  height: 23px;
  line-height: 23px;
  margin-top: 10px;
}
.top-body-right-two-1 {
  text-align: center;
  width: 22%;
  background: #faaa14;
  border-radius: 5px;
  float: left;
}
.top-body-right-two-4{
  text-align: center;
  width: 22%;
  border-radius: 5px;
  float: left;
  border: 1px solid #587cf7;
  color: #587cf7;
}
.top-body-right-two-2 {
  width: 18%;
  text-align: center;
  margin-left: 15px;
  border-radius: 5px;
  border: 1px solid #587cf7;
  color: #587cf7;
  float: left;
}
.top-body-right-two-3 {
  float: left;
  margin-left: 15px;
  width: 50%;
  text-align: center;
  border-radius: 5px;
  border: 1px solid #dadce6;
}
.top-body-right-three {
  margin-top: 10px;
  height: 55px;
  width: 100%;
  border-top: 1px dashed rgb(224, 219, 219);
  border-bottom: 1px dashed rgb(232, 228, 228);
  font-size: 16px;
  line-height: 55px;
}
.top-body-right-three-1 {
  float: left;
}
.top-body-right-three-1-1{
  float: left;
}
.top-body-right-three-1-2{
  float: left;
  margin-left: 10px;
}
.top-body-right-three-2 {
  float: left;
  margin-left: 25px;
}
.top-body-right-three-2-1{
  float: left;
}
.top-body-right-three-2-2{
  margin-left: 10px;
  float: left;
}
.top-body-right-four {
  margin-top: 10px;
}
.top-body-right-four-1{
  float: left;
  margin-left: -50%;
}
.top-body-right-four-2{
  float: right;
  text-align: center;
  line-height: 40px;
}
.top-body-right-four-2:hover{
  color: red;
}


.second-body {
  padding: 25px;
  background: #f8f9fc;
  padding-left: 12%;
  flex-direction: column;
  flex-grow: 1;
}
.second-body-size {
  color: #141933;
  font-size: 16px;
  font-weight: 500;
  padding-top: 25px;
}
.second-body-one {
  float: left;
  width: 60%;
}
.second-body-one-2 {
  border-radius: 25px;
  background: #ffffff;
  margin: 15px 0px;
  padding: 25px 100px;
}
.second-body-two {
  float: left;
  width: 25%;
  margin-left: 25px;
  position: sticky;
  top: 0;
}
.second-body-two-2 {
  border-radius: 25px;
  background: #ffffff;
  text-align: center;
  margin: 15px 0px;
}
.second-body-two-3 {
  margin-top: 10px;
  color: #141933;
  font-size: 16px;
  font-weight: 500;
  margin-top: 16px;
}
.second-body-two-4 {
  margin-top: 10px;
  position: relative;
  font-size: 13px;
  color: #7a7f99;
  line-height: 30px;
}
.second-body-two-5 {
  text-align: center;
}
.message-schoolFeature {
  position: relative;
  font-size: 13px;
  color: #7a7f99;
  padding: 0 10px;
  margin-right: 8px;
  border-radius: 12px;
  border: 1px solid #d8dce6;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/view/recruitment/mutualSelection.vue